<script setup>
import MobileAboutUs from "@variants/seer/aboutus/m/index.vue";
import PcAboutUs from "@variants/seer/aboutus/pc/index.vue";

const { $isMobile } = useNuxtApp();

definePageMeta({
	"m-showNavBar": true,
	"m-showFooter": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "aboutUs.meta.breadcrumb",
});

// 同步挂载真实页面，让静态内容和页面自己的新闻骨架从第一帧直接显示。
const DynamicComponent = $isMobile ? MobileAboutUs : PcAboutUs;
</script>

<template>
	<main>
		<DynamicComponent />
	</main>
</template>
